module.exports = __webpack_public_path__ + "static/media/brochure-revcon-presentacion.b23f28d7.png";